import * as React from 'react'
import {
  OpportunityDatePicker,
  SalesFunnelSelect,
} from '@user/components/Opportunities/AddOpportunity/AddOpportunityForm/Fields'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'
import Stack from '@mui/material/Stack'
import { CustomFieldList } from './CustomFieldList'
import { ENTITY_TYPES } from '@sales-center/common'
import Box from '@mui/material/Box'
import { useSelectCustomFieldData } from '@user/store/customFields'

type Props = {
  entityType: ENTITY_TYPES
}

export function OpportunityFields(props: Props) {
  const data = useSelectCustomFieldData()

  return (
    <Stack direction="column">
      <SalesFunnelSelect<ISaveServicesForLaterFormModel>
        disabled={false}
        hideOptional={false}
        name="salesFunnelId"
        required
        size="small"
        whiteBackground
        width={320}
      />
      <Box sx={{ width: '320px' }}>
        <OpportunityDatePicker
          disabled={false}
          hideOptional={false}
          disablePast={true}
          name="expectedClosingDate"
          label="Expected Closing Date"
          required
          whiteBackground
          isSaveForLaterType
        />
      </Box>
      <CustomFieldList {...data} {...props} />
    </Stack>
  )
}
